import { useEffect, useState } from "react";
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;1,300;1,400&family=Outfit:wght@300;400;500;600&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  :root{
    --gold:#C9A84C;--gold-light:#E8C97A;--gold-dim:#8A6E30;
    --black:#0A0A08;--surface:#161614;--card:#1C1C19;
    --white:#F5F2EC;--dim:#B8B4A8;--muted:#6B6860;
    --serif:'Cormorant Garamond',Georgia,serif;--sans:'Outfit',sans-serif;
  }
  html{scroll-behavior:smooth}
  body{background:var(--black) !important;color:var(--white);font-family:var(--sans);font-weight:300;line-height:1.7;overflow-x:hidden}
  .st-wrap{background:var(--black);color:var(--white);font-family:var(--sans);font-weight:300;line-height:1.7;min-height:100vh}
  a{color:inherit;text-decoration:none}
  .st-nav{padding:16px 48px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid rgba(201,168,76,0.1);position:sticky;top:0;background:rgba(10,10,8,0.92);backdrop-filter:blur(16px);z-index:10;transition:padding 0.3s}
  .st-nav-logo{font-family:var(--serif);font-size:22px;font-weight:500;color:var(--gold);letter-spacing:0.02em}
  .st-nav-links{display:flex;gap:32px;align-items:center}
  .st-nav-links a{font-size:12px;font-weight:400;letter-spacing:0.1em;text-transform:uppercase;color:var(--dim);transition:color 0.2s}
  .st-nav-links a:hover{color:var(--gold)}
  .st-nav-cta{background:transparent;border:1px solid var(--gold);color:var(--gold) !important;padding:9px 22px;font-size:11px;font-weight:500;letter-spacing:0.12em;text-transform:uppercase;transition:all 0.25s;display:inline-block}
  .st-nav-cta:hover{background:var(--gold);color:var(--black) !important}
  .st-hamburger{display:none;flex-direction:column;gap:5px;cursor:pointer;padding:4px;background:none;border:none}
  .st-hamburger span{display:block;width:24px;height:1.5px;background:var(--gold);transition:all 0.3s}
  .st-hamburger.open span:nth-child(1){transform:translateY(6.5px) rotate(45deg)}
  .st-hamburger.open span:nth-child(2){opacity:0}
  .st-hamburger.open span:nth-child(3){transform:translateY(-6.5px) rotate(-45deg)}
  .st-mobile-menu{display:none;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(10,10,8,0.98);z-index:99;flex-direction:column;align-items:center;justify-content:center;gap:40px}
  .st-mobile-menu.open{display:flex}
  .st-mobile-menu a{font-size:24px;font-family:var(--serif);font-weight:300;color:var(--dim);letter-spacing:0.05em;transition:color 0.2s}
  .st-mobile-menu a:hover{color:var(--gold)}
  .st-mobile-mcta{font-size:14px !important;font-family:var(--sans) !important;font-weight:500 !important;letter-spacing:0.12em !important;text-transform:uppercase;border:1px solid var(--gold);color:var(--gold) !important;padding:14px 36px;margin-top:16px}
  .st-hero{padding:80px 48px 64px;max-width:860px}
  .st-tag{display:inline-block;background:rgba(201,168,76,0.08);border:1px solid rgba(201,168,76,0.2);color:var(--gold);font-size:10px;letter-spacing:0.16em;text-transform:uppercase;padding:6px 16px;margin-bottom:32px}
  .st-h1{font-family:var(--serif);font-size:clamp(42px,5.5vw,68px);font-weight:300;line-height:1.07;color:var(--white);margin-bottom:24px;letter-spacing:-0.01em}
  .st-h1 em{font-style:italic;color:var(--gold)}
  .st-hero-sub{font-size:16px;color:var(--dim);line-height:1.85;max-width:640px}
  .st-hero-sub strong{color:var(--white);font-weight:500}
  .st-divider{height:1px;background:linear-gradient(to right,rgba(201,168,76,0.3),transparent);margin:0 48px}
  .st-gap{padding:64px 48px;background:var(--surface)}
  .st-gap-inner{display:grid;grid-template-columns:1fr 1.4fr;gap:56px;align-items:center}
  .st-gap-stat{text-align:center;padding:40px;background:var(--black);border:1px solid rgba(201,168,76,0.15)}
  .st-gap-num{font-family:var(--serif);font-size:80px;font-weight:300;color:var(--gold);line-height:1;margin-bottom:10px}
  .st-gap-label{font-size:14px;color:var(--dim);line-height:1.65;margin-bottom:8px}
  .st-gap-source{font-size:10px;color:var(--gold-dim);letter-spacing:0.08em}
  .st-gap-text h3{font-family:var(--serif);font-size:30px;font-weight:300;color:var(--white);margin-bottom:18px;line-height:1.2}
  .st-gap-text p{font-size:15px;color:var(--dim);line-height:1.85;margin-bottom:16px}
  .st-gap-text p strong{color:var(--white);font-weight:500}
  .st-flow{padding:64px 48px}
  .st-flow h2{font-family:var(--serif);font-size:32px;font-weight:300;color:var(--white);margin-bottom:40px}
  .st-flow-grid{display:grid;grid-template-columns:1fr 36px 1fr 36px 1fr;align-items:center}
  .st-fstep{background:var(--surface);border:1px solid rgba(201,168,76,0.1);padding:32px 28px}
  .st-fstep.hl{background:var(--card);border-color:rgba(201,168,76,0.3);position:relative}
  .st-fstep.hl::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:var(--gold)}
  .st-farr{display:flex;align-items:center;justify-content:center;color:var(--gold);font-size:20px}
  .st-ficon{font-size:28px;margin-bottom:14px}
  .st-flabel{font-size:9px;letter-spacing:0.16em;text-transform:uppercase;color:var(--gold-dim);margin-bottom:10px}
  .st-ftitle{font-family:var(--serif);font-size:22px;font-weight:400;color:var(--white);margin-bottom:10px}
  .st-fdesc{font-size:13px;color:var(--muted);line-height:1.7}
  .st-stats{padding:0 48px 64px}
  .st-stats-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:1px;background:rgba(201,168,76,0.1);border:1px solid rgba(201,168,76,0.1)}
  .st-stat{background:var(--card);padding:32px 20px;text-align:center}
  .st-snum{font-family:var(--serif);font-size:48px;font-weight:300;color:var(--gold);line-height:1;margin-bottom:10px}
  .st-slabel{font-size:12px;color:var(--dim);line-height:1.55;margin-bottom:8px}
  .st-ssource{font-size:9px;color:var(--gold-dim);letter-spacing:0.06em}
  .st-ops{padding:0 48px 64px}
  .st-ops h2{font-family:var(--serif);font-size:30px;font-weight:300;color:var(--white);margin-bottom:10px}
  .st-ops p{font-size:14px;color:var(--dim);margin-bottom:32px;line-height:1.75}
  .st-ops-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1px;background:rgba(201,168,76,0.1);border:1px solid rgba(201,168,76,0.1)}
  .st-op{background:var(--surface);padding:28px 24px;position:relative;overflow:hidden;transition:background 0.25s}
  .st-op::after{content:'';position:absolute;bottom:0;left:0;right:0;height:2px;background:var(--gold);transform:scaleX(0);transform-origin:left;transition:transform 0.35s}
  .st-op:hover{background:var(--card)}
  .st-op:hover::after{transform:scaleX(1)}
  .st-op-icon{font-size:24px;margin-bottom:12px}
  .st-op-type{font-size:9px;letter-spacing:0.12em;text-transform:uppercase;color:var(--gold-dim);margin-bottom:10px}
  .st-op-title{font-family:var(--serif);font-size:18px;font-weight:400;color:var(--white);margin-bottom:10px;line-height:1.3}
  .st-op-desc{font-size:13px;color:var(--muted);line-height:1.7}
  .st-wyg{padding:64px 48px;background:var(--surface)}
  .st-wyg h2{font-family:var(--serif);font-size:30px;font-weight:300;color:var(--white);margin-bottom:36px}
  .st-wyg-grid{display:grid;grid-template-columns:1fr 1fr;gap:1px;background:rgba(201,168,76,0.1);border:1px solid rgba(201,168,76,0.1)}
  .st-wyg-item{background:var(--surface);padding:28px 32px;display:flex;gap:18px;align-items:flex-start}
  .st-wyg-dot{width:6px;height:6px;background:var(--gold);flex-shrink:0;margin-top:9px}
  .st-wyg-title{font-size:14px;font-weight:500;color:var(--white);margin-bottom:6px;letter-spacing:0.02em}
  .st-wyg-desc{font-size:13px;color:var(--muted);line-height:1.7}
  .st-cta{padding:80px 48px;text-align:center;position:relative;overflow:hidden;background:var(--black)}
  .st-cta-glow{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:600px;height:400px;background:radial-gradient(ellipse,rgba(201,168,76,0.06) 0%,transparent 70%);pointer-events:none}
  .st-cta h2{font-family:var(--serif);font-size:40px;font-weight:300;color:var(--white);margin-bottom:20px;position:relative;line-height:1.15}
  .st-cta h2 em{font-style:italic;color:var(--gold)}
  .st-cta p{font-size:16px;color:var(--dim);max-width:480px;margin:0 auto 48px;line-height:1.8;position:relative}
  .st-cta-divider{width:1px;height:44px;background:linear-gradient(to bottom,transparent,var(--gold-dim));margin:0 auto 44px;position:relative}
  .st-bp{background:var(--gold);color:var(--black);padding:16px 40px;font-size:12px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;display:inline-block;cursor:pointer;position:relative;transition:background 0.25s;border:none}
  .st-bp:hover{background:var(--gold-light)}
  .st-cta-note{font-size:11px;color:var(--muted);margin-top:16px;position:relative}
  .st-footer{padding:32px 48px;border-top:1px solid rgba(201,168,76,0.08);display:flex;justify-content:space-between;align-items:center;background:var(--black)}
  .st-footer-logo{font-family:var(--serif);font-size:16px;color:var(--gold)}
  .st-footer-copy{font-size:11px;color:var(--muted)}
  .st-r{opacity:0;transform:translateY(24px);transition:opacity 0.75s ease,transform 0.75s ease}
  .st-r.st-v{opacity:1;transform:none}
  .st-d1{transition-delay:0.1s}.st-d2{transition-delay:0.2s}.st-d3{transition-delay:0.3s}
  @media(max-width:768px){
    .st-nav,.st-hero,.st-gap,.st-flow,.st-stats,.st-ops,.st-wyg,.st-cta,.st-footer{padding-left:24px;padding-right:24px}
    .st-nav-links{display:none}
    .st-hamburger{display:flex;margin-left:auto}
    .st-gap-inner{grid-template-columns:1fr}
    .st-flow-grid{grid-template-columns:1fr}
    .st-farr{display:none}
    .st-stats-grid{grid-template-columns:1fr 1fr}
    .st-ops-grid{grid-template-columns:1fr}
    .st-wyg-grid{grid-template-columns:1fr}
    .st-h1{font-size:38px}
  }
`;
const ops = [["🚛", "Trucking & Fleet", "Your fleet covers the route. We cover the follow-through.", "As your trucks move through a market, we capture the audience along the route and retarget them digitally — turning route coverage into measurable reach."], ["🚕", "Taxi & Rideshare Wraps", "Every ride becomes a two-screen campaign.", "Someone sees the taxi wrap on 5th Ave. Minutes later, they see the same brand on their phone. That\'s not coincidence — that\'s The Second Touch."], ["🚌", "Transit & Bus", "Commuters see you twice — on the bus and on their phone.", "We map transit corridors and capture audiences along your routes for digital follow-up — turning commuter eyeballs into accountable impressions."], ["📋", "Billboards & Static OOH", "Your billboard now has a digital twin.", "We define the area around your board and retarget every device that passed through — so the message follows the audience home."], ["🏪", "Retail & Place-Based", "In-store exposure, extended digitally.", "Audiences in or near your retail network get a digital follow-up — driving return visits and measurable foot traffic lift."], ["📺", "Connected TV Extension", "From the street to the living room.", "We extend your OOH audience to connected TV — so the brand that reached them outdoors reaches them again on the biggest screen in their home."]];
const wyg = [["A new premium offering", "Add The Second Touch to your media packages and charge more. You\'re selling outcomes, not just impressions."], ["Advertiser retention", "When advertisers can see results, they renew. Measurement turns one-time buys into recurring revenue."], ["No new infrastructure", "We build and operate the digital layer. You sell it. No tech team, no platform investment required on your end."], ["Performance reporting", "Clean, client-ready reports showing reach, engagement, and store visitation — delivered for every campaign."], ["Works with any inventory", "Trucks, taxis, transit, billboards, retail — if it\'s physical and it reaches people, we can layer digital onto it."], ["Aligned incentives", "We offer performance-based engagement structures. We win when your advertisers see results."]];
export default function SecondTouchPage() {
  const [menuOpen, setMenuOpen] = (useState as any)(false);
  const closeMobileMenu = () => {
    setMenuOpen(false);
    document.body.style.overflow = "";
  };
  const toggleMenu = () => {
    setMenuOpen((prev: boolean) => {
      const next = !prev;
      document.body.style.overflow = next ? "hidden" : "";
      return next;
    });
  };
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = styles;
    document.head.appendChild(style);
    document.title = "OOH Mobile Solution — Maximize Your Inventory Revenue | AdStack Alpha";
    const obs = new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) (e.target as HTMLElement).classList.add("st-v");
    }), {
      threshold: 0.1
    });
    document.querySelectorAll(".st-r").forEach(el => obs.observe(el));
    const handleScroll = () => {
      const nav = document.querySelector("nav.st-nav") as HTMLElement;
      if (nav) nav.style.padding = window.scrollY > 60 ? "10px 48px" : "16px 48px";
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      document.head.removeChild(style);
      obs.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <div className="st-wrap">

      {/* NAV */}
      <nav className="st-nav">
        <div className="st-nav-logo">AdStack Alpha</div>
        <div className="st-nav-links">
          <a href="https://www.adstackalpha.com#aa-ooh">For OOH Operators</a>
          <a href="https://www.adstackalpha.com#aa-agency">For Agencies</a>
          <a href="https://www.adstackalpha.com#aa-about">About</a>
          <a href="https://calendly.com/abhishek-adstackalpha/30min" target="_blank" rel="noopener noreferrer" className="st-nav-cta">Book a Strategy Call</a>
        </div>
        <button className={`st-hamburger${menuOpen ? " open" : ""}`} onClick={toggleMenu} aria-label="Menu">
          <span /><span /><span />
        </button>
      </nav>

      <div className={`st-mobile-menu${menuOpen ? " open" : ""}`}>
        <a href="https://www.adstackalpha.com#aa-ooh" onClick={closeMobileMenu}>For OOH Operators</a>
        <a href="https://www.adstackalpha.com#aa-agency" onClick={closeMobileMenu}>For Agencies</a>
        <a href="https://www.adstackalpha.com#aa-about" onClick={closeMobileMenu}>About</a>
        <a href="https://calendly.com/abhishek-adstackalpha/30min" target="_blank" rel="noopener noreferrer" className="st-mobile-mcta" onClick={closeMobileMenu}>Book a Strategy Call</a>
      </div>

      {/* HERO */}
      <div className="st-hero st-r">
        <div className="st-tag">The Second Touch — For OOH Operators</div>
        <h1 className="st-h1">Your physical ad is<br />the first impression.<br /><em>We make sure<br />it&apos;s not the last.</em></h1>
        <p className="st-hero-sub">Most OOH operators sell one impression — someone sees the truck, the taxi wrap, the billboard — and that&apos;s where the story ends. But your physical ad is already generating digital signals your advertisers aren&apos;t capturing. <strong>The Second Touch closes that loop.</strong></p>
      </div>

      <div className="st-divider" />

      {/* GAP */}
      <div className="st-gap">
        <div className="st-gap-inner">
          <div className="st-gap-stat st-r">
            <div className="st-gap-num">26%</div>
            <div className="st-gap-label">of all search activations are generated by OOH — on just 7% of the media budget</div>
            <div className="st-gap-source">Nielsen / OAAA</div>
          </div>
          <div className="st-gap-text st-r st-d1">
            <h3>Your ads are already driving digital behavior. You&apos;re just not capturing it.</h3>
            <p>Every time someone sees your billboard, your truck wrap, your taxi — they pull out their phone. They search. They visit. They act. OOH punches far above its weight in driving digital response.</p>
            <p><strong>The Second Touch captures that audience and follows up with a digital ad — turning a single exposure into a measurable, multi-touch campaign.</strong></p>
          </div>
        </div>
      </div>

      {/* FLOW */}
      <div className="st-flow">
        <h2 className="st-r">How The Second Touch works</h2>
        <div className="st-flow-grid">
          <div className="st-fstep st-r">
            <div className="st-ficon">🚛</div>
            <div className="st-flabel">Step 1 — First Touch</div>
            <div className="st-ftitle">Your Physical Ad</div>
            <div className="st-fdesc">Truck wrap, taxi, billboard, transit — someone sees it in the real world. The impression lands.</div>
          </div>
          <div className="st-farr st-r">→</div>
          <div className="st-fstep hl st-r st-d1">
            <div className="st-ficon">📱</div>
            <div className="st-flabel">Step 2 — The Second Touch</div>
            <div className="st-ftitle">We Follow Up</div>
            <div className="st-fdesc">We capture that audience and serve them the same brand message on their phone, tablet, or connected TV.</div>
          </div>
          <div className="st-farr st-r st-d1">→</div>
          <div className="st-fstep st-r st-d2">
            <div className="st-ficon">📊</div>
            <div className="st-flabel">Step 3 — Proof</div>
            <div className="st-ftitle">You Show Results</div>
            <div className="st-fdesc">Store visits, engagement, reach. Your advertiser sees exactly what their spend produced — and renews.</div>
          </div>
        </div>
      </div>

      {/* STATS */}
      <div className="st-stats">
        <div className="st-stats-grid">
          {[["76%", "of OOH viewers took action after seeing a DOOH ad", "OAAA / Harris Poll, 2024"], ["43%", "visited a business within 30 minutes of seeing an OOH ad", "OAAA / Morning Consult"], ["38%", "uplift in mobile action when OOH and digital run together", "Outsmart / Campaign"], ["26%", "of search activations driven by OOH on just 7% of budget", "Nielsen / OAAA"]].map(([num, label, source], i) => <div key={i} className="st-stat st-r" style={{
          transitionDelay: `${i * 0.1}s`
        }}>
              <div className="st-snum">{num}</div>
              <div className="st-slabel">{label}</div>
              <div className="st-ssource">{source}</div>
            </div>)}
        </div>
      </div>

      {/* OPERATORS */}
      <div className="st-ops">
        <h2 className="st-r">Built for how you actually operate</h2>
        <p className="st-r st-d1">Whether you run trucks, taxis, transit, or billboards — The Second Touch works with your existing inventory. No new infrastructure required.</p>
        <div className="st-ops-grid">
          {ops.map(([icon, type, title, desc], i) => <div key={i} className="st-op st-r" style={{
          transitionDelay: `${i % 3 * 0.1}s`
        }}>
              <div className="st-op-icon">{icon}</div>
              <div className="st-op-type">{type}</div>
              <div className="st-op-title">{title}</div>
              <div className="st-op-desc">{desc}</div>
            </div>)}
        </div>
      </div>

      {/* WHAT YOU GET */}
      <div className="st-wyg">
        <h2 className="st-r">What you get as an operator</h2>
        <div className="st-wyg-grid">
          {wyg.map(([title, desc], i) => <div key={i} className="st-wyg-item st-r" style={{
          transitionDelay: `${i % 2 * 0.1}s`
        }}>
              <div className="st-wyg-dot" />
              <div>
                <div className="st-wyg-title">{title}</div>
                <div className="st-wyg-desc">{desc}</div>
              </div>
            </div>)}
        </div>
      </div>

      {/* CTA */}
      <div className="st-cta">
        <div className="st-cta-glow" />
        <h2 className="st-r">Ready to add <em>The Second Touch</em><br />to your operation?</h2>
        <div className="st-cta-divider st-r st-d1" />
        <p className="st-r st-d1">A 30-minute call is all it takes to figure out whether this works for your inventory and your advertisers. No pitch. Just a direct conversation.</p>
        <a href="https://calendly.com/abhishek-adstackalpha/30min" target="_blank" rel="noopener noreferrer" className="st-bp st-r st-d2">Book a 30-minute strategy call →</a>
        <div className="st-cta-note st-r st-d3">Free. No obligation. Just a conversation.</div>
      </div>

      {/* FOOTER */}
      <div className="st-footer">
        <div className="st-footer-logo">AdStack Alpha</div>
        <div className="st-footer-copy">© 2025 AdStack Alpha LLC. All rights reserved.</div>
      </div>

    </div>;
}